"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EBasketCardEventStatusKey = void 0;
var EBasketCardEventStatusKey;
(function (EBasketCardEventStatusKey) {
    EBasketCardEventStatusKey[EBasketCardEventStatusKey["LOADING"] = 0] = "LOADING";
    EBasketCardEventStatusKey[EBasketCardEventStatusKey["OUTCOME"] = 1] = "OUTCOME";
    EBasketCardEventStatusKey["EVENT_CANCELED"] = "event canceled";
    EBasketCardEventStatusKey["EVENT_INTERRUPTED"] = "event interrupted";
    EBasketCardEventStatusKey["EVENT_POSTPONED"] = "event postponed";
    EBasketCardEventStatusKey["EVENT_ENDED"] = "event ended";
    EBasketCardEventStatusKey["EVENT_SUSPENDED"] = "event suspended";
    EBasketCardEventStatusKey["OUTCOME_NOT_AVAILABLE"] = "outcome not available";
})(EBasketCardEventStatusKey || (exports.EBasketCardEventStatusKey = EBasketCardEventStatusKey = {}));
//# sourceMappingURL=basket.types.js.map